"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LocationServices;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _semanticUiReact = require("semantic-ui-react");
var _lodash = require("lodash");
var _components = require("@bluefin/components");
var _LocationServices = require("./LocationServices.utils");
var _index = require("../../index");
var _types = require("../../types");
var _service = require("../../types/service");
require("./LocationServices.less");
var propTypes = {
  items: _propTypes["default"].arrayOf(_service.CatalogItemPropType).isRequired,
  allItems: _propTypes["default"].arrayOf(_service.CatalogItemPropType).isRequired,
  allCategories: _propTypes["default"].arrayOf(_service.CatalogCategoryPropType).isRequired,
  priceRangeProps: _types.ObjectPropType,
  itemGridProps: _types.ObjectPropType,
  displaySchedules: _propTypes["default"].bool,
  renderItem: _propTypes["default"].func
};
var defaultProps = {
  priceRangeProps: {},
  itemGridProps: {},
  displaySchedules: true,
  renderItem: function renderItem(_ref) {
    var item = _ref.item,
      allItems = _ref.allItems,
      allCategories = _ref.allCategories,
      priceRangeProps = _ref.priceRangeProps;
    var _ref2 = item || {},
      itemName = _ref2.name,
      variations = _ref2.variations;
    return /*#__PURE__*/_react["default"].createElement(_components.FadeReveal, {
      triggerOnce: true
    }, /*#__PURE__*/_react["default"].createElement(_components.InternalLink, {
      className: "item content",
      to: (0, _index.createServiceItemSlug)(item, allItems, allCategories)
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
      as: "h5"
    }, itemName), /*#__PURE__*/_react["default"].createElement(_components.PriceRange, (0, _extends2["default"])({
      prices: variations.map(function (_ref3) {
        var price = _ref3.price;
        return {
          amount: price
        };
      }),
      settings: {
        displayType: 'range',
        displayZeroCost: false
      }
    }, priceRangeProps || {}))));
  }
};
function LocationServices(_ref4) {
  var items = _ref4.items,
    allItems = _ref4.allItems,
    allCategories = _ref4.allCategories,
    priceRangeProps = _ref4.priceRangeProps,
    displaySchedulesProp = _ref4.displaySchedules,
    itemGridProps = _ref4.itemGridProps,
    renderItem = _ref4.renderItem;
  var _useSemanticUiProps = (0, _components.useSemanticUiProps)(),
    getGridProps = _useSemanticUiProps.getGridProps;
  if ((0, _lodash.isEmpty)(items)) {
    return null;
  }
  var schedulesItems = (0, _LocationServices.transformItemsToSchedules)(items);
  var displaySchedules = schedulesItems.length > 1 && displaySchedulesProp;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "location-services-container"
  }, schedulesItems.map(function (_ref5) {
    var scheduleName = _ref5.name,
      categories = _ref5.categories;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "schedule",
      key: scheduleName
    }, displaySchedules && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
      as: "h3"
    }, scheduleName), categories.map(function (category) {
      var categoryName = category.name,
        categoryItems = category.items;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "category",
        key: categoryName
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
        as: "h4"
      }, categoryName), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, (0, _extends2["default"])({
        columns: 2,
        doubling: true,
        stackable: true
      }, getGridProps(itemGridProps)), categoryItems.map(function (item) {
        var itemName = item.name;
        return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
          key: itemName
        }, renderItem({
          item: item,
          allItems: allItems,
          allCategories: allCategories,
          priceRangeProps: priceRangeProps
        }));
      })));
    }));
  }));
}
LocationServices.propTypes = propTypes;
LocationServices.defaultProps = defaultProps;